import { defineMessages } from 'react-intl';
const scope = 'library.components.Demo';
export const messages = defineMessages({
  title: {
    id: "".concat(scope, ".title"),
    defaultMessage: 'Hello world!!'
  }
});